export const odluka_naknada_troskova_prijevoza_na_posao_i_s_posla = {
    templateId: 42,
    category: 4,
    templateTitle: 'Odluka - naknada troškova prijevoza na posao i s posla',
    templateDescription: `<p>Poslodavac može (odnosno mora, ukoliko ga na to obvezuje pravilnik o radu, kolektivni ugovor i sl.) neoporezivo isplatiti radniku naknadu troškova prijevoza na posao i s posla mjesnim i međumjesnim javnim prijevozom, u visini stvarnih izdataka prema cijeni mjesečne odnosno pojedinačne prijevozne karte. Navedena isplata je neoporeziva do visine stvarnih izdataka prema cijeni mjesečne odnosno pojedinačne prijevozne karte odnosno do visine cijene mjesečne odnosno pojedinačne prijevozne karte, a ako nema organiziranog prijevoza do visine cijene prijevoza koja je utvrđena na približno jednakim udaljenostima na kojima je organiziran prijevoz.</p>`,
    description: `
    <h5><strong>OPIS DOKUMENTA</strong></h5>
    <p>Pravilnikom o porezu na dohodak propisani su primici koji se ne smatraju plaćom i na koje se ne plaća porez na dohodak - neoporezive isplate.</p>
    <p>U navedene primitke ubraja se i naknada troškova prijevoza na posao i s posla.</p>
    <p>Međutim, ukoliko navedeno pravo nije propisano pravilnikom o radu ili kolektivnim ugovorom odnosno ako nije određeno ugovorom o radu, onda poslodavac samostalno odlučuje hoće li to pravo omogućiti radniku i u kojem opsegu (u cijelosti ili djelomično).</p>
    <p>Poslodavac može neoporezivo radniku isplatiti naknadu troškova prijevoza na posao i s posla mjesnim i međumjesnim javnim prijevozom u visini stvarnih izdataka.</p>
    <p>Naknade troškova prijevoza na posao i s posla može se neoporezivo isplatiti u/do visine stvarnih izdataka prema cijeni:</p>
    <li> mjesečne ili</li>
    <li> pojedinačne prijevozne karte.</li>
    <br>
    <p>Pri tome se podrazumijeva kako cijena mjesnog prijevoza, tako i međumjesnog prijevoza.</p>
    <p>Ako na određenom području odnosno udaljenosti <strong>nema</strong> ​organiziranog prijevoza, naknada troškova prijevoza na posao i s posla utvrđuje se u visini cijene prijevoza koja je utvrđena na približno jednakim udaljenostima na kojima je organiziran prijevoz odnosno do visine cijene prijevoza koja je utvrđena na približno jednakim udaljenostima na kojima je organiziran prijevoz</p>
    <p>Ako radnik mora sa stanice međumjesnog javnog prijevoza koristiti i mjesni prijevoz, stvarni izdaci utvrđuju se u visini troškova mjesnog i međumjesnoga javnoga prijevoza odnosno do visine stvarnih izdataka utvrđenih u visini troškova mjesnog i međumjesnoga javnoga prijevoza.</p>
    <p>Pravilnikom o porezu na dohodak određeno je da se isplate naknade troškova prijevoza na posao i s posla mjesnim javnim prijevozom priznaju na temelju vjerodostojnih isprava (računa, obračuna, odluka, potvrda o cijeni karata i drugog).</p>
    <p>Prema sljedećim mišljenjima Porezne uprave:</p> 

    <p>
    <a target="_blank" href="https://www.porezna-uprava.hr/HR_publikacije/Lists/mislenje33/Display.aspx?id=19490">Mišljenje 1</a>, </p>
    <p>
    <a target="_blank" href="http://www.porezna-uprava.hr/HR_publikacije/Lists/mislenje33/Display.aspx?ID=18831&ContentTypeId=0x0100EC713B67E7E91E4CB070B8F49D6747B1">Mišljenje 2</a>.</p> 
    
    <p>vjerodostojnom ispravom smatraju i javno objavljeni odnosno dostupni cjenici ovlaštenih prijevoznika koje su poslodavci radi priznavanja neoporezivih iznosa obvezni čuvati u svojim službenim evidencijama te predočiti u slučaju nadzora.</p>
    <p>U slučajevima kada poslodavac odluči isplaćivati naknadu troškova prijevoza prema cijeni pojedinačne prijevozne karte, cijena karte množi se s brojem dana koje je radnika radio u tom mjesecu te se u tom smislu ne može priznati za one dane kad radnik nije dolazio na posao (npr. bolovanje, godišnji odmor i sl.).</p>
    <p>Također, ukoliko se poslodavac odlučio isplaćivati naknadu troškova prijevoza prema cijeni pojedinačne prijevozne karte, istu ne može isplatiti ukoliko radnik cijeli mjesec nije radio iz bilo kojeg razloga - bolovanje (privremena nesposobnost za rad), plaćeni odnosno neplaćeni dopust u skladu s posebnim propisima i sl..</p>
    <p>Naknada troškova prijevoza na posao i s posla je porezno priznati trošak s aspekta utvrđivanja osnovice poreza na dobit, no do visine stvarnih izdataka troška prijevoza.</p>
    <p>Osim toga, prema odredbama Ovršnog zakona, naknada troškova prijevoza na posao i s posla do visine stvarnih izdataka izuzeta je od ovrhe te se u slučaju blokade računa radnika uplaćuje se na račun radnika koji je zaštićen od ovrhe na novčanim sredstvima (tzv. zaštićeni račun).</p>
    <p>Poslodavac može naknadu prijevoznih troškova isplatiti radniku u gotovini iz blagajne ili na tekući račun, a isplata može biti obavljena uz isplatu redovne plaće ili posebno.</p>
    <p>Ako poslodavac radniku isplaćuje troškove prijevoza na posao i s posla, a radnik ne koristi javni prijevoz, nego koristi osobni automobil, isplaćena naknada ne smatra se oporezivim primitkom do visine cijene mjesečne odnosno pojedinačne prijevozne karte bilo kojeg prijevoznika koji prometuje na tom području (mišljenje Porezne uprave , Broj klase:410-01/16-01/2725 Urudžbeni broj:513-07-21-01/17-2 Zagreb, 25.01.2017.)</p>
    <h5><strong>SVRHA DOKUMENTA</strong></h5>
    <p>Naknada troškova prijevoza koje radnik ima povodom dolaska na posao i odlaska s posla.</p>
    <h5><strong>NAJČEŠĆE GREŠKE</strong></h5>
    <p><strong>- Isplaćivanje naknade, iako radnik nije nazočan na radnom mjestu.</strong></p>
    <p>Pojašnjenje: navedeno može predstavljati osnovu za pokretanje prekršajnog postupka.</p>
    <p><strong>- Isplata naknade bez valjanje dokumentacije (vjerodostojne isprave koje dokazuju visinu troškova prijevoza)</strong></p>
    <p>Pojašnjenje: navedeno može predstavljati osnovu za pokretanje prekršajnog postupka.</p>
    <h5><strong>PRAVNA OSNOVA</strong></h5>
    <p>Zakon o porezu na dohodak, Pravilnik o porezu na dohodak, Ovršni zakon.</p>
  `,
    sides: [
        {
            prefix: 'Na temelju Zakona o porezu na dohodak i Pravilnika o porezu na dohodak,',
            signature: 'Za Poslodavca:',
            inputs: [{
                type: "input",
                required: true,
                placeholder: "Poslovni subjekt",
              },
              {
                type: "input",
                required: true,
                placeholder: "Ulica i kućni broj",
              },
              {
                type: "input",
                required: true,
                placeholder: "Mjesto",
              },
              {
                type: "input",
                required: true,
                placeholder: "OIB",
              },
              {
                type: "input",
                placeholder: "Zastupa",
                inSignature: true,
              },
              {
                type: "input",
                placeholder: "Funkcija",
                inSignature: true,
              }],
              suffix: ' (u daljnjem tekstu: Poslodavac),',
        }
    ],

    headline: 'donosi sljedeću',
    title: ' ODLUKU O NAKNADI TROŠKOVA PRIJEVOZA NA POSAO I S POSLA',
    noArticleNumbers: true,

    articles: [
        {
            title: '',
            mandatory: true,
            statements: [
                {
                    type: 'choice',
                    mandatory: true,
                    editable: false,
                    choices: [
                        {
                            parts: [
                                {
                                    type: 'text',  help: "Ovu točku trebate odabrati ukoliko odluku donosite za sve radnike.",
                                    content: 'Ovom Odlukom uređuje se pravo radnika na naknadu troškova prijevoza na posao i s posla kod Poslodavca i visina naknade (u daljnjem tekstu: Naknada).' }]
                        },
                        {
                            parts: [
                                {
                                    type: 'text',
                                    content: 'Ovom Odlukom uređuje se pravo radnika'
                                },
                                { type: 'input', value: '', required: true, placeholder: "Ime i prezime" },
                                { type: "text", content: "," },
                                { type: 'text', content: 'iz',},
                                { type: 'input', value: '', required: true, placeholder: "Mjesto"   },
                                { type: 'text', content: ',' },
                                { type: 'input', value: '', required: true, placeholder: "Ulica i kućni broj" },
                                { type: "text", content: "," },
                                { type: 'text', content: 'OIB:' },
                                { type: "input",  required: true,},
                                {
                                    help: "Ovu točku trebate odabrati ukoliko odluku donosite za svakog pojedinog radnika.",
                                    type: 'text',
                                    content: ', (u daljnjem tekstu: Radnik) na naknadu troškova prijevoza na posao i s posla kod Poslodavca te visina naknade (u daljnjem tekstu: Naknada).'
                               }
                            ]
                        }],
                    value: '',
                }
            ]
        },
        {
            title: '',
            mandatory: true,
            statements: [
                {
                    type: 'choice',
                    mandatory: true,
                    choices: [
                        {
                            parts: [
                                {
                                    type: 'text',
                                    content: 'Naknada iz ove Odluke se ostvaruje u visini stvarnih izdataka, prema cijeni pojedinačne prijevozne karte mjesnog odnosno međumjesnog prijevoza.'
                                }]
                        },
                        {
                            parts: [
                                {
                                    type: 'text',
                                    content: 'Naknada iz ove Odluke se ostvaruje u visini stvarnih izdataka, prema cijeni mjesečne prijevozne karte mjesnog odnosno međumjesnog prijevoza.'
                                }]
                        },
                        {
                            parts: [
                                {
                                    type: 'text',
                                    content: 'Radnicima kojima stvarni izdatak mjesnog odnosno međumjesnog prijevoza ne prelazi'
                                },
                                {type: 'input', value: '', required: true},
                                {
                                    type: 'text',
                                    content: 'kn, Naknada se isplaćuje do punog iznosa, dok radnicima kojima stvarni izdatak mjesnog odnosno međumjesnog prijevoza prelazi'
                                },
                                {type: 'input', value: '', required: true},
                                {type: 'text', content: 'kn, isplaćuje se Naknada u iznosu od'},
                                {type: 'input', value: '', required: true},
                                {type: 'text', content: 'kn, koji predstavlja najveći iznos Naknade koju Poslodavac isplaćuje.'}]
                        }],
                    value: '',
                }
            ]
        },
        {
            title: '',
            mandatory: true,
            statements: [
                {
                    type: 'text',
                    mandatory: true,
                    editable: true,
                    content: 'Ako radnik mora sa stanice međumjesnog javnog prijevoza koristiti i mjesni prijevoz, stvarni izdaci utvrđuju se u visini troškova mjesnog i međumjesnoga javnoga prijevoza odnosno do visine stvarnih izdataka utvrđenih u visini troškova mjesnog i međumjesnoga javnoga prijevoza.',
                    value: '',
                }],
        },
        {
            title: '',
            mandatory: true,
            statements: [
                {
                    type: 'text',
                    mandatory: true,
                    editable: true,
                    content: 'Ako se radnik ne može koristiti sredstvima javnog prijevoza, ima pravo na Naknadu troškova u visini cijene prijevoza koju imaju drugi radnici slične udaljenosti.',
                    value: '',
                }],
        },
        {
            title: '',
            mandatory: true,
            statements: [
                {
                    type: 'text',
                    mandatory: true,
                    editable: true,
                    content: 'Radnik ima pravo na Naknadu troškova prijevoza na posao i s posla samo za one dane odnosno mjesece koje radi i za koje ostvaruje trošak prijevoza.',
                    value: '',
                }],
        },
        {
            title: '',
            mandatory: true,
            statements: [
                {
                    type: 'choice',
                    mandatory: true,
                    editable: false,
                    choices: [
                        {
                            parts: [
                                {
                                    type: 'text',
                                    content: 'Naknada iz ove Odluke isplaćuje u razdobljima isplate plaće.'
                                }]
                        },
                        {
                            parts: [
                                {
                                    type: 'text',
                                    content: 'Naknada iz ove Odluke isplaćuje se do'
                                },
                                {type: 'input', value: '', required: true},
                                {type: 'text', content: '- og u mjesecu za prethodni mjesec.'}]
                        }],
                    value: '',
                }
            ]
        },
        {
            title: '',
            mandatory: true,
            statements: [
                {
                    type: 'choice',
                    mandatory: true,
                    editable: true,
                    choices: [
                        'Naknada iz ove Odluke isplaćuje se na redovan račun radnika, no u slučaju da radnik ima otvoren zaštićeni račun, sredstva se doznačuju na zaštićeni račun.',
                        'Naknada iz ove Odluke isplaćuje se u gotovini.',
                        'Poslodavac samostalno odlučuje u svakom pojedinom slučaju na koji način će se isplatiti Naknada Radniku, u gotovini ili na redovan račun Radnika (no u slučaju da radnik ima otvoren zaštićeni račun, sredstva se doznačuju na zaštićeni račun).'
                    ],
                    placeholder: "Odaberite ovdje te potom izmijenite po želji...",
                    help: 'Prije odabira načina isplate molimo pažljivo pročitajte tekst gore u kojemu se navodi u kojim slučajevima je dopuštena isplata troškova prijevoza na posao i s posla, u gotovini.'
                }
            ]
        },
        {
            title: '',
            mandatory: false,
            statements: [
                {
                    type: 'text',
                    mandatory: true,
                    editable: true,
                    content: 'Ukoliko radnik koristi službeno vozilo Poslodavca, nema pravo na naknadu troškova prijevoza na posao i s posla. ',
                    value: '',
                }],
        },
        {
            title: '',
            mandatory: true,
            statements: [
                {
                    type: 'text',
                    mandatory: true,
                    editable: true,
                    content: 'Odluka stupa na snagu danom donošenja.',
                    value: '',
                }],
        },
        {
            mandatory: true,
            static: true,
            type: 2, // date and place
            statements: [
              {
                type: "input",
                mandatory: true,
                parts: [
                  {
                    type: "text",
                    content: "U"
                  },
                  {
                    type: "input",
                    value: "",
                    placeholder: "Upišite mjesto.",
                    required: true,
                  },
                  {
                    type: "text",
                    content: ", dana"
                  },
                  {
                    type: "date",
                    value: new Date(),
                    required: true
                  },
                  {
                    type: "text",
                    content: "godine."
                  }
                ]
              },
            ]
          },
        {
            mandatory: true,
            static: true,
            type: 3,  // signatures
            statements: [],
        },
        {
            static: true,
            mandatory: false,
            type: 4, 
            statements: [
                {
                    type: 'text',
                    mandatory: true,
                    editable: true,
                    content: 'Dostaviti:\r\n1) Radniku/Radnicima\r\n2) Kadrovska služba \r\n3) Obračun plaća',
                    help: 'Po želji, slobodno dopišite kome želite dostaviti odluku odnosno izmijenite/obrišite predložene unose.'
                }
            ]
        },
    ],
};


// WEBPACK FOOTER //
// C:/Projects/milic/self-legal/src/app/contracts/42_odluka_naknada_troskova_prijevoza_na_posao_i_s_posla.ts